<template>
  <div class="introduction-container">
    <h1 class="title">
      <span class="emphasize">零投入</span>
      <span>开启美团充电宝</span>
    </h1>
    <h2 class="subtitle">
      极速审核通过 快速查看后台交易
    </h2>
    <div class="slogan-panel">
      <div class="slogan-item convenient">
        安装省心便捷
      </div>
      <div class="slogan-item customer">
        提升顾客进店率
      </div>
      <div class="slogan-item income">
        分润账目清晰
      </div>
    </div>
    <div class="brand-panel">
      <div class="brand-image"></div>
    </div>
  </div>
</template>

<script>
import KNB from '@dp/knb';
import config from '@/config';

export default {
  name: 'Introduction',
  created() {
    let url = '';
    if (config.env === 'production') {
      url = 'https://cube.meituan.com/cube/block/4f73b5bf708c4248885a/176838/index.html?lch=a87_bkdb1_ckdbfbanner_d176838';
    } else {
      url = 'http://cube.hfe.test.meituan.com/cube/block/test/c738e1186c57/3536/index.html?lch=a87_bmessage_ctest_d3536';
    }
    if (this.$isWXApplet) {
      window.location.replace(url);
    } else {
      KNB.jumpPage({
        url,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.introduction-container {
  position: relative;
  min-height: 100%;
  padding: 6px 0 210px;
  background: #FFF;
  .title {
    height: 84px;
    line-height: 84px;
    margin-bottom: 9px;
    font-size: 60px;
    font-weight: bold;
    color: rgba(0, 0, 0, .84);
  }
  .emphasize {
    color: #FF8800;
  }
  .subtitle {
    height: 40px;
    line-height: 40px;
    margin-bottom: 48px;
    font-size: 28px;
    color: rgba(0, 0, 0, .42);
  }
  .slogan-panel {
    display: flex;
    width: 678px;
    margin: 0 auto 72px;
    .slogan-item {
      flex: 1;
      line-height: 1;
      padding-top: 113.5px;
      font-size: 26px;
      &.convenient {
        background: url(~@/assets/img/convenient-icon@3x.png) no-repeat center top;
        background-size: 96px;
      }
      &.customer {
        background: url(~@/assets/img/customer-icon@3x.png) no-repeat center top;
        background-size: 96px;
      }
      &.income {
        background: url(~@/assets/img/income-icon@3x.png) no-repeat center top;
        background-size: 96px;
      }
    }
  }
  .brand-panel {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 600px;
    height: 600px;
    padding-top: 171px;
    border-radius: 50%;
    background-image: linear-gradient(-145deg, #FFDB47 1%, #FFD23C 100%);
    transform: translate(-50%, -206px);
  }
  .brand-image {
    position: relative;
    width: 583px;
    height: 370px;
    margin: 0 auto;
    background: url(~@/assets/img/brand-image@3x.png) no-repeat;
    background-size: 100%;
  }
  .bottom-btns {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    bottom: env(safe-area-inset-bottom);
    padding: 30px 36px;
    .call-btn {
      display: block;
      flex: 1;
    }
  }
}
</style>
